import { from } from '../observable/from';
import { Observable } from '../Observable';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function exhaustMap(project) {
    return function (source) {
        return new Observable(function (subscriber) {
            var index = 0;
            var innerSub = null;
            var isComplete = false;
            source.subscribe(createOperatorSubscriber(subscriber, function (outerValue) {
                if (!innerSub) {
                    innerSub = createOperatorSubscriber(subscriber, undefined, function () {
                        innerSub = null;
                        isComplete && subscriber.complete();
                    });
                    from(project(outerValue, index++)).subscribe(innerSub);
                }
            }, function () {
                isComplete = true;
                !innerSub && subscriber.complete();
            }));
        });
    };
}
//# sourceMappingURL=exhaustMap.js.map